import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "form-explanation text-2xl mb-8" }, " Hatırlatma mesajı, seçeceğiniz tarihte sabah saat 09:00'da, göreve sorumlu olarak eklenen tüm kullanıcılara gönderilir. Eğer hatırlatma mesajını siz de almak istiyorsanız, lütfen potansiyelin sorumlular listesinde olduğunuzdan emin olun. ", -1)
const _hoisted_2 = { class: "ac-form-control" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "reminderDate" }, "Hatırlatma Tarihi", -1)
const _hoisted_4 = ["min"]
const _hoisted_5 = { class: "ac-form-control" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "reminderMessage" }, "Hatırlatma Mesajı", -1)
const _hoisted_7 = { class: "ac-button-row flex items-center justify-center gap-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "ac-primary-button"
}, "Gönder", -1)

import type { AcReminder } from "~/types/application";
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'addReminderForm',
  emits: ["reminder-added", "cancelled"],
  setup(__props, { emit: __emit }) {

const emits = __emit

const reminder = ref<Partial<AcReminder>>({
    date: "",
    additionalMessage: "",
})

// Get tomorrow's date in YYYY-MM-DD format for min date
const getTomorrowDate = () => {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    return tomorrow.toISOString().split('T')[0]
}

const minDate = getTomorrowDate()

// Convert date picker value to DD/MM/YYYY format
const handleDateChange = (event: Event) => {
    const target = event.target as HTMLInputElement
    const dateValue = target.value // This will be in YYYY-MM-DD format from date picker
    
    if (dateValue) {
        // Extract year to check if it's a complete/reasonable date
        const [year, month, day] = dateValue.split('-')
        
        // Only validate if the year is complete (4 digits) and reasonable
        if (year && year.length === 4 && parseInt(year) >= new Date().getFullYear()) {
            const selectedDate = new Date(dateValue)
            const tomorrow = new Date()
            tomorrow.setDate(tomorrow.getDate() + 1)
            tomorrow.setHours(0, 0, 0, 0)
            
            if (selectedDate < tomorrow) {
                // Reset the input if date is today or earlier
                target.value = ""
                reminder.value.date = ""
                alert("Hatırlatma tarihi bugünden sonraki bir tarih olmalıdır.")
                return
            }
        }
        
        // Convert YYYY-MM-DD to DD/MM/YYYY (only if we have all parts)
        if (year && month && day && year.length === 4) {
            reminder.value.date = `${day}/${month}/${year}`
        }
    } else {
        reminder.value.date = ""
    }
}

const addReminder = () => {
    emits("reminder-added", reminder.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(addReminder, ["prevent"]),
    class: "ac-main-form !border-none"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        type: "date",
        id: "reminderDate",
        min: _unref(minDate),
        onChange: handleDateChange
      }, null, 40, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("textarea", {
        placeholder: "Hatırlatma için ek bir mesaj girmek istiyorsanız buradan girebilirsiniz.",
        id: "reminderMessage",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reminder.value.additionalMessage) = $event))
      }, null, 512), [
        [_vModelText, reminder.value.additionalMessage]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("button", {
        type: "button",
        class: "ac-secondary-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('cancelled')))
      }, "İptal")
    ])
  ], 32))
}
}

})